import { Layout, Spin } from "antd";
import { Content } from "antd/es/layout/layout";
import styled from "styled-components";
import { MyMenu } from "./menu";

export const MyContent = styled(Content)`
  padding: 16px 24px;
  width: 100%;

  gap: 16px;

  @media (max-width: 768px) {
    padding: 12px 16px;
    gap: 12px;
  }

  @media (max-width: 500px) {
    padding: 8px 12px;
    gap: 8px;
  }
`;

export const LoginedLayout = ({ children, path, loading, title }: any) => {
  return (
    <>
      <Layout style={{ minHeight: "100vh" }}>
        <MyMenu />
        <MyContent>
          {loading ? <Spin size="large" style={{ width: "100%", marginTop: 20 }} /> : children}
        </MyContent>
      </Layout>
    </>
  );
};
